import * as React from 'react';
import debounce from 'lodash/debounce';
import { InView } from 'react-intersection-observer';

import { TextLabel } from '@wix/wix-base-ui';

import CardImage from '../CardImage';
import CardPrimaryButton from '../CardPrimaryButton';
import CardSecondaryButton from '../CardSecondaryButton';
import formatDate from '../../utils/formatDate';
import { BI_EVENTS } from '../../constants';

import { IAnnouncementItem, WithSendBi } from '../../types';

import styles from './Card.scss';

interface CardProps extends IAnnouncementItem, WithSendBi {
  position: number;
  isNew: boolean;
}

const ON_VIEWED_TIME = 3000;
const EXTERNAL_LINK_TYPE = 'EXTERNAL_LINK';

const hasExternalLink = (actions): boolean =>
  actions.length && actions[0].type === EXTERNAL_LINK_TYPE;

class CardComponent extends React.Component<CardProps> {
  static displayName = 'Card';

  isViewed: boolean = false;

  onViewed = debounce((inView: boolean) => {
    if (!inView || this.isViewed) {
      return;
    }

    this.isViewed = true;
    this.props.sendBI(BI_EVENTS.CARD_VIEWED, {
      card_position: this.props.position,
      announcement_id: this.props.id,
    });
  }, ON_VIEWED_TIME);

  render() {
    const {
      id,
      position,
      title,
      description,
      publishDate,
      asset,
      primaryActions,
      secondaryActions,
      isNew,
      sendBI,
    } = this.props;

    return (
      <InView threshold={0.75} onChange={this.onViewed}>
        <div className={styles.card}>
          {isNew && (
            <div className={styles.badge}>
              <TextLabel type="T21" value="NEW" shouldTranslate={false} />
            </div>
          )}

          <div className={styles.date}>
            <TextLabel
              type="T04"
              value={formatDate(publishDate)}
              shouldTranslate={false}
            />
          </div>

          <div className={styles.title}>
            <TextLabel
              type="T19"
              value={title}
              enableEllipsis={false}
              shouldTranslate={false}
            />
          </div>

          {asset && <CardImage {...asset} />}

          <div className={styles.description}>
            <TextLabel
              type="T02"
              value={description}
              enableEllipsis={false}
              shouldTranslate={false}
            />
          </div>

          <div className={styles.buttonGroup}>
            {hasExternalLink(primaryActions) ? (
              <CardPrimaryButton
                id={id}
                position={position}
                {...primaryActions[0]}
                sendBI={sendBI}
              />
            ) : null}
            {hasExternalLink(secondaryActions) ? (
              <CardSecondaryButton
                id={id}
                position={position}
                {...secondaryActions[0]}
                sendBI={sendBI}
              />
            ) : null}
          </div>
        </div>
      </InView>
    );
  }
}

export default CardComponent;
